import { timestamp } from 'components/columns';
import { Period, TruncatedList } from 'components';
import { EnterpriseLink } from 'components/EnterpriseLink';
import { BookingStateBadge, PaymentStateBadge, InvoiceSource } from '../common';
import { fmtMonth } from 'utilities';
import type { ListExpense } from './types';
import { CompanyTitle } from 'modules/core/company/components';
import { IsLinkedStateBadge } from '../common/IsLinkedStateBadge';
import { DocumentApplicationStateBadge } from '../common/DocumentApplicationStateBadge';
import { LinkApplicationStateBadge } from '../common/LinkApplicationStateBadge';
import { TableColumns } from '@ff-it/ui';
import { InvoiceStateTag } from '../common/InvoiceStateTag';
import { InvoiceTypeIcon } from '../InvoiceTypeIcon';
import { OverflowContainer } from 'components/OverflowContainer/OverflowContainer';
import { datesColumns, totalsColumn } from '../common/columns';

export const columns: TableColumns<ListExpense> = [
  {
    width: 30,
    key: 'type',
    render: ({ type }: ListExpense) => <InvoiceTypeIcon direction="expense" type={type} />,
    sortable: false,
    cellProps: {
      textAlign: 'center',
      flush: true,
    },
  },
  {
    cellProps: { className: 'pl-0' },
    content: 'Number',
    key: 'display_number',
    minWidth: 120,
    maxWidth: 200,
    // absolute link since we use it in nested lists
    render: ({ id, number }: ListExpense) => (
      <OverflowContainer title={number}>
        <EnterpriseLink to={`/invoices/expense/${id}`}>{number}</EnterpriseLink>
      </OverflowContainer>
    ),
  },
  {
    content: 'State',
    width: 40,
    cellProps: { flush: true, textAlign: 'center' },
    key: 'state',
    sortable: false,
    render: ({ state }) => <InvoiceStateTag state={state} appearance="naked" iconOnly />,
  },
  {
    key: '_',
    render: (i) => <InvoiceSource {...i} />,
    cellProps: { className: 'px-0 text-center' },
    width: 30,
  },
  {
    cellProps: { className: 'pl-0 py-1' },
    headerCellProps: { className: 'pl-0' },
    content: 'Provider',
    key: 'partner.title',
    minWidth: 120,
    sortable: true,
    render: ({ partner }) => <CompanyTitle {...partner} />,
  },
  {
    content: 'Clients',
    key: 'clients',
    cellProps: {
      className: 'py-1',
    },
    minWidth: 120,
    render: ({ clients }: ListExpense) => (
      <TruncatedList limit={1} items={clients} getKey={(o) => o.id} renderItem={CompanyTitle} />
    ),
  },
  {
    cellProps: { className: 'py-0' },
    content: 'Finance per.',
    key: 'finance_period',
    render: ({ finance_period }) =>
      finance_period ? <Period date_from={finance_period.start} date_to={finance_period.end} fmt={fmtMonth} /> : null,
    minWidth: 120,
  },
  timestamp('Created', 'created_at', { sortable: true }),
  datesColumns,
  totalsColumn,
  {
    width: '120px',
    cellProps: { className: 'px-0' },
    key: 'sums',
    render: (invoice: ListExpense) => (
      <>
        <PaymentStateBadge state={invoice.sums.paym_state} />
        <BookingStateBadge state={invoice.state} booking_state={invoice.booking_state} />
        <IsLinkedStateBadge linked_at={invoice.linked_at} link_state={invoice.sums.link_state} />
        <LinkApplicationStateBadge direction={invoice.direction} link_state={invoice.sums.link_state} />
        <DocumentApplicationStateBadge invoice={invoice} />
      </>
    ),
  },
];
